<template>
    <CardRh :processando="processando">
        <div class="disciplina-aluno-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3" v-if="status">
                        <label for="statusMatricula" class="form-label">Status </label>
                        <Multiselect id="statusMatricula" v-model="status_id" :options="status_select"
                            :searchable="true" @change="refreshTable" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-3" v-if="tipos_nota_select.length">
                        <label for="provaTipoAluno" class="form-label">Avaliacao</label>
                        <Multiselect id="provaTipoAluno" v-model="prova_tipo_id" :options="tipos_nota_select"
                            :searchable="true" @change="refreshTable" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="pelotaoAluno" class="form-label">Pelotao</label>
                        <input id="pelotaoAluno" v-model="pelotao" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pelotao" />
                    </div>

                    <div class="col-12 col-lg-4 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                        <button v-if="prova_tipo_id && hasPermissaoEditar && status_id && disciplina.tipo.id == 2" type="button"
                            class="btn btn-sm btn-light border border-success" title="Aprovar em lote"
                            @click="aprovarLote">
                            <i class="fa fa-check-double bi fs-2x"></i>
                            <span class="fs-4">Aprovar em lote</span>
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false"
                    @tableatualizada="tableatualizada($event)">
                    <th>Aluno</th>
                    <th>Pelotao</th>
                    <th>Situacao</th>
                    <th class="text-center" v-if="disciplina.tipo.id == 2">Acoes</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CardRh from "@/components/cards/ManzaCard.vue";
import MatriculaService from "@/service/v1/sigap/MatriculaService";
import NotaService from "@/service/v1/sigap/NotaService";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { Prop } from 'vue-property-decorator';
import Multiselect from '@vueform/multiselect';
import $ from "jquery";

@Options({
    name: "DisciplinaNotaPendenteIndex",
    components: { Multiselect, CardRh, KDataTable },
})
export default class DisciplinaNotaPendenteIndex extends Vue {
    @Prop() readonly disciplina!: any;
    @Prop() readonly perfis!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public serviceNota = new NotaService();
    public pelotao: any = null;
    public turmaId: any = null;
    public disciplinaId: any = null;
    public status_id: any = 1;
    public status: any = null;
    public tiposNota: any = null;
    public prova_tipo_id: any = null;

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public buscaTiposProva() {
        this.processando = true;
        this.serviceNota.getTipo()
            .then(response => {
                this.tiposNota = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    get tipos_nota_select() {
        if (this.tiposNota) {
            const filtrados = this.tiposNota.filter(tipo => {
                if (parseInt(this.disciplina?.quantiadadeAvaliacao) >= parseInt(tipo.id)) {
                    return true;
                }
                if (parseInt(this.disciplina?.quantidadeTrabalho) + 5 >= parseInt(tipo.id)) {
                    if (parseInt(tipo.id) > 5) {
                        return true;
                    }
                }
                if (parseInt(tipo.id) >= 16) {
                    return true;
                }
                return false;
            });
            return filtrados.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    pushColunaAcoes() {
        this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.status_id = null;
        this.prova_tipo_id = null;
        this.pelotao = null;
        this.refreshTable();
    }

    created() {
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new MatriculaService();
        this.disciplinaId = this.$route.params.id;
        this.turmaId = this.disciplina.turmaId;
        this.buscaTiposProva();
        this.getStatus();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    pelotao: this.pelotao,
                    status: this.status_id,
                    disciplinaId: this.disciplinaId,
                    turmaId: this.turmaId,
                    notaTipoId: this.prova_tipo_id,
                    search: d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[1, 'asc'],[0, 'asc']];
        this.config.columns = [
            { data: 'usuario.nome', name: 'usuario' },
            { data: 'pelotao', name: 'pelotao' },
            { data: 'status', name: 'status', class: 'desktop text-center', searchable: false },
        ];

        this.config.columnDefs = [
            {
                targets: 2,
                render: (row) => {
                    return row != null ? row.nome : '';
                },
            },
        ];

        if (this.disciplina.tipo.id == 2) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-success btn-sm" btn-aprovar ' + buttom + ' title="Aprovar"><i class="fa fa-check"></i> Aprovar</button>';
                        return this.prova_tipo_id && this.hasPermissaoEditar ? texto : '';
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $('[btn-aprovar]').click((btn) => {
            setTimeout(() => {
                const dados: any = {};
                dados.matriculaId = $(btn.currentTarget).data().id;
                dados.disciplinaId = this.disciplina.id;
                dados.notaValor = '10';
                dados.tipo = this.prova_tipo_id;
                dados.status = 1;
                this.aprovar(dados);
            }, 10);
        });
    }

    public aprovar(dados: any) {
        if (this.processando || !this.hasPermissao || !this.prova_tipo_id) {
            return;
        }
        if (parseInt(this.prova_tipo_id) >= 16) {
            SiteUtils.toastErro('Error!', 'Nao e possivel lancar nota para este tipo de prova!');
            return;
        }
        this.processando = true;
        setTimeout(() => {
            this.serviceNota.cadastrar(dados)
                .then(response => {
                    SiteUtils.toastSucesso('Cadastrado com sucesso!', response.message);
                    this.refreshTable();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Error!', error.data.message);
                });
        }, 100);
    }

    protected aprovarLote() {
        SiteUtils.alertConfimacao('Atencao!!!', 'Vai ser aprovados todos os alunos listado abaixo, deseja continuar?',
            () => {
                this.aprovarLoteApi();
            }
        );
    }

    public aprovarLoteApi() {
        if (this.processando || !this.hasPermissao || !this.prova_tipo_id) {
            return;
        }
        if (parseInt(this.prova_tipo_id) >= 16) {
            SiteUtils.toastErro('Error!', 'Nao e possivel lancar nota para este tipo de prova!');
            return;
        }

        this.processando = true;
        const dados: any = {};
        dados.disciplinaId = this.disciplinaId;
        dados.turmaId = this.turmaId;
        dados.provaTipo = this.prova_tipo_id;
        dados.pelotao = this.pelotao;
        dados.status = this.status_id;
        setTimeout(() => {
            this.serviceNota.cadastrarLote(dados)
                .then(response => {
                    SiteUtils.toastSucesso('Cadastrado com sucesso!', response.message);
                    this.refreshTable();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Error!', error.data.message);
                });
        }, 100);
    }
}
</script>

<style scoped>
.disciplina-aluno-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
